import {BasicEntity} from '../../framework/message/BasicEntity';

export class UserTrack extends BasicEntity {
creationTime: number | null;
key: string;
login: string;
tab: string;
valor: string;
vision: string;
widget: string;
}

